import { Component, OnInit } from '@angular/core';
import { JackpotService } from '@app/core/jackpot.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-jackpot-keys-modal',
  templateUrl: './jackpot-keys-modal.template.html',
  styleUrls: ['./jackpot-keys-modal.template.scss'],
  animations: [],
})
export class JackpotKeysModalComponent implements OnInit {
  jackpotId: string;
  keyCount: number = 0;
  info: any[];

  constructor(public jackpotService: JackpotService, private route: ActivatedRoute) {}

  public ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.jackpotId = params.jid;
    });

    if (this.jackpotId) {
      this.jackpotService.getJackpotInfo(this.jackpotId).then(data => {
        this.keyCount = data.count;
        this.info = data.items;
      });
    } else {
      this.jackpotService.getInfo();
      this.info = this.jackpotService._info.keys;
      this.keyCount = this.jackpotService._info.keys.length;
    }
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/jackpot-keys/jackpot-keys-modal.component.ts